import api from './api';

class ReclutamientoApi {
    static async createReclutamiento(reclutamientoData) {
        return api.post('/reclutamiento', reclutamientoData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async uploadFile(reclutamientoId, formData) {
        return api.post(`/reclutamiento/${reclutamientoId}/documentos`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static async getReclutamiento(reclutamientoId) {
        return api.get(`/reclutamiento/${reclutamientoId}`);
    }

    static async validateToken(token) {
        return api.get(`/reclutamiento/validate-token/${token}`);
    }

    static async invalidateToken(token) {
        return api.post(`/reclutamiento/invalidate-token/${token}`);
    }
}

export default ReclutamientoApi;
